import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TransitionContextType {
  shouldAnimate: boolean;
  setShouldAnimate: (animate: boolean) => void;
}

const TransitionContext = createContext<TransitionContextType | undefined>(undefined);

export const useTransition = () => {
  const context = useContext(TransitionContext);
  if (context === undefined) {
    throw new Error('useTransition must be used within a TransitionProvider');
  }
  return context;
};

interface TransitionProviderProps {
  children: ReactNode;
}

export const TransitionProvider: React.FC<TransitionProviderProps> = ({ children }) => {
  const [shouldAnimate, setShouldAnimate] = useState(false);

  return (
    <TransitionContext.Provider value={{ shouldAnimate, setShouldAnimate }}>
      {children}
    </TransitionContext.Provider>
  );
};
